var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.cart !== null)?_c('AsiCard',{attrs:{"icon":_vm.icons.cart,"title":_vm.$t('cart.singular'),"unwrapped":""}},[_c('CartContent',{attrs:{"id":_vm.cart.id,"hide-checkout-button":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }